import { render, staticRenderFns } from "./CampusEditar.vue?vue&type=template&id=d55bf30c"
import script from "./CampusEditar.vue?vue&type=script&lang=js"
export * from "./CampusEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports